var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner_page_layout"},[_c('AppHeaderVue'),_c('div',{staticClass:"layout-sec"},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1)]),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }